var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$parent.$parent.rerender)?_c('div',{staticClass:"row myrow content-mb-42"},[_c('div',{staticClass:"col-xs-12 mycol",class:{
      'has-error': _vm.$parent.$parent.checkErrorField(
        'PROJECTS',
        'LOGIC',
        'UF_MARKER_PRODUCTS_ID'
      )
    }},[_c('Multiselect',{staticClass:"i-main-style i-wid-50 multiselect-filter-project-register multiselect-multiline",attrs:{"label":"NAME","limit":1,"multiple":false,"limitText":_vm.filterItemText,"track-by":"ID","disabled":_vm.$parent.$parent.projectDisabled,"options":_vm.filterMarkerList,"placeholder":""},on:{"input":_vm.changeMarker},model:{value:(_vm.$parent.project.UF_MARKER_PRODUCTS_ID_ARR),callback:function ($$v) {_vm.$set(_vm.$parent.project, "UF_MARKER_PRODUCTS_ID_ARR", $$v)},expression:"$parent.project.UF_MARKER_PRODUCTS_ID_ARR"}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("\n      "+_vm._s(_vm.$parent.$parent.checkErrorText(
          "PROJECTS",
          "LOGIC",
          "UF_MARKER_PRODUCTS_ID"
        ))+"\n    ")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }